import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["innerHTML"]

import { onBeforeMount } from 'vue'

import ArticleLayout from '@/app/components/article/Layout.vue'

import AudioPlayer from '@/app/components/doc/player/Player.vue'
import AudioPlayerDisabled from '@/app/components/doc/player/PlayerDisabled.vue'
import Annotator from '@/app/components/doc/reading/Annotator.vue'
import EOCButton from '@/app/components/billing/EOCButton.vue'

import { ArticleView } from '@/models/doc.article'
import { emitter } from '@/services/mitt'
import { formatDate } from '@/helpers/time'
import { parseTextForTranslation } from '@/services/weglot'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'Content',
  props: {
    article: {}
  },
  setup(__props: any) {

const props = __props

onBeforeMount(async () => {
  Mixpanel.setFirstDoc('Viewed', props.article.title, props.article.doc_type)
})

function publishDate(): string {
  if (props.article.original_publish_date) {
    return formatDate(props.article.original_publish_date)
  }
  return ''
}

/**
 * We use the `getHtml` function instead of writing this directly since
 * 1) we want to use the v-html directive to render article.page.text
 * 2) the title, author, and blurb need to be annotatable, which means
 *    they need to be children of the `.sf-chapter` div.
 * See issue #4109.
 */
function getHtml(): string {
  // If the blurb exists, we add H3 after it, which renders the horizontal line.
  const blurbHtml =
    `<p>${props.article.blurb}</p>` + (props.article.blurb ? '<h3></h3>' : '')

  return `<div>
        <h2 class="article-single__title">${props.article.title}</h2>
        <p>
          <span class="article-single__author text-gray">
            By ${props.article.author}
            <span class="line"></span>
            <a
              href="${props.article.original_url}"
              target="_blank"
              class="article-single__publisher-link"
            >
              Published ${publishDate()} in
              <em>${props.article.publisher.name}</em></a
            >
            ${getSubscribeLink()}
          </span>
        </p>
        ${blurbHtml}
     </div>
     ${parseTextForTranslation(props.article.page.text)}`
}

function getSubscribeLink(): string {
  if (!props.article.publisher.subscribe_url) {
    return ''
  }
  return `
      <span class="line"></span>
      <a
        href="${props.article.publisher.subscribe_url}"
        target="_blank"
      >Subscribe</a>`
}

function onDocContentClick(event: any): void {
  emitter.emit('docContentClicked', event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ArticleLayout, { article: __props.article }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["article-single__content-editor article-single__content-editor--no-border content-editor", __props.article.settings.cssClass]),
        style: _normalizeStyle({ 'font-family': __props.article.settings.fontFamily }),
        onClick: onDocContentClick
      }, [
        _createElementVNode("img", {
          class: "article-single__cover",
          src: __props.article.cover_image,
          alt: ""
        }, null, 8, _hoisted_1),
        _createVNode(Annotator, {
          content: __props.article.page
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "sf-chapter",
              oncopy: "return false",
              innerHTML: getHtml()
            }, null, 8, _hoisted_2),
            (__props.article.isChapterEOC)
              ? (_openBlock(), _createBlock(EOCButton, {
                  key: 0,
                  text: "Subscribe to Read Full Article",
                  "ios-text": "Full Subscription Required to Read More"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["content"])
      ], 6),
      (__props.article.audio && __props.article.controls.isPlayerRendered)
        ? (_openBlock(), _createBlock(AudioPlayer, {
            key: 0,
            doc: __props.article
          }, null, 8, ["doc"]))
        : _createCommentVNode("", true),
      (
        !__props.article.audio && __props.article.has_audio && __props.article.controls.isPlayerRendered
      )
        ? (_openBlock(), _createBlock(AudioPlayerDisabled, {
            key: 1,
            class: _normalizeClass(__props.article.controls.playerClass)
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["article"]))
}
}

})